import { Badge, Button } from "@/components/ui";
import { Typography } from "@/components/ui/Typography/Typography";
import type { MatterSubItemType } from "@/lib/types";
import { cn } from "@/lib/utils/cn";
import { ExternalLink } from "lucide-react";

export interface MatterBreadcrumbProps {
  items: {
    id: string;
    type: MatterSubItemType | "Matter" | "Task";
    title?: string;
    onClick?: () => void;
    onNavigateClick?: () => void;
    disableNavigation?: boolean;
  }[];
  className?: string;
}

export const MatterBreadcrumb = ({
  items,
  className,
}: MatterBreadcrumbProps) => {
  return (
    <Badge
      variant="secondary"
      className={cn(
        "border-border bg-muted text-foreground flex min-w-0 flex-wrap items-center gap-x-1.5 gap-y-0 rounded-full px-3 py-0.5",
        className,
      )}
    >
      {items.map((item, index) => (
        <div key={item.id} className="flex w-fit items-center">
          {index > 0 && (
            <Typography className="text-muted-foreground px-1">/</Typography>
          )}
          <Button
            variant="link"
            className={cn(
              "h-6 cursor-default p-0 hover:no-underline",
              item.onClick &&
                !item.disableNavigation &&
                "cursor-pointer hover:underline",
            )}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              if (item.onClick && !item.disableNavigation) {
                item.onClick();
              }
            }}
          >
            <Typography
              size="sm"
              weight="medium"
              className={cn(
                "text-foreground flex items-center",
                item.onClick &&
                  !item.disableNavigation &&
                  "cursor-pointer hover:underline",
              )}
            >
              {item.title ?? item.type}
            </Typography>
          </Button>
          {item.onNavigateClick && !item.disableNavigation && (
            <Button
              variant="link"
              size="icon"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (item.onNavigateClick && !item.disableNavigation) {
                  item.onNavigateClick();
                }
              }}
              className="text-foreground hover:text-primary h-4 w-4 cursor-pointer pb-1 pl-2 font-normal"
            >
              <ExternalLink className="h-3 w-3" />
            </Button>
          )}
        </div>
      ))}
    </Badge>
  );
};
